module.exports = __webpack_public_path__ + "img/cd.0452ab11.png";